import Immutable from 'immutable';
import { acceptTermsOfService } from '../Application/asyncActions';
import {
  FETCH_LOGGED_IN_USER_DATA_SUCCESS,
  FETCH_LOGGED_IN_USER_TOS_ACCEPTANCE_DATES_SUCCESS,
} from './actions';

/*
 * This data is kept outside of the User store as it contains all the logged in profiles data
 * that doesn't fit the shape of a User (so that all objects in the User store are consistent)
 */

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function LoggedInUser(state = Immutable.Map(), action) {
  switch (action.type) {
    case FETCH_LOGGED_IN_USER_DATA_SUCCESS: {
      const { userData } = action;

      const { emailAddress, timezone, tosAcceptanceDates } = userData;
      const myData = { emailAddress, timezone, tosAcceptanceDates };
      return state.merge(Immutable.fromJS(myData));
    }
    case FETCH_LOGGED_IN_USER_TOS_ACCEPTANCE_DATES_SUCCESS: {
      const dates = action.dates ? Immutable.fromJS(action.dates) : null;
      return state.set('tosAcceptanceDates', dates);
    }
    case acceptTermsOfService.fulfilled.toString():
      return state.setIn(
        ['tosAcceptanceDates', action.payload.type],
        action.payload.timestamp
      );
    default: {
      return state;
    }
  }
}
